"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1021],{

/***/ 68085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _src_client_cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);
/* harmony import */ var _src_client_components_offers_logic_use_get_active_promo_offer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8235);
/* harmony import */ var _src_client_components_offers_logic_use_get_all_placeholders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38153);



// @ts-expect-error - Automatic, Please fix when editing this file
var useGetOffersContent = function(param) {
    var shouldSkip = param.shouldSkip;
    var ref = (0,_src_client_components_offers_logic_use_get_active_promo_offer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        skip: shouldSkip,
        targetSegment: _src_client_cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE
    }), activeOffers = ref.activeOffers, isLoadingOffers = ref.loading;
    var ref1 = (0,_src_client_components_offers_logic_use_get_all_placeholders__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        skip: shouldSkip
    }), placeholders = ref1.placeholders, isLoadingPlaceHolders = ref1.loading;
    return {
        activeOffers: activeOffers,
        loading: isLoadingOffers || isLoadingPlaceHolders,
        placeholders: placeholders
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetOffersContent);


/***/ }),

/***/ 9010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ banner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/generate-portable-text/index.js
var generate_portable_text = __webpack_require__(5398);
var generate_portable_text_default = /*#__PURE__*/__webpack_require__.n(generate_portable_text);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/components/offers/utils/filterOffers/index.tsx
var filterOffers = __webpack_require__(91186);
// EXTERNAL MODULE: ./src/client/components/offers/tile/utils/get-content-for-offer/index.ts
var get_content_for_offer = __webpack_require__(95897);
;// CONCATENATED MODULE: ./src/client/components/offers/utils/has-end-punctuation/index.ts
var END_OF_SENTENCE_PUNCTUATION = /([?!.,:-])$/;
var hasEndPunctuation = function(text) {
    return END_OF_SENTENCE_PUNCTUATION.test(text);
};
/* harmony default export */ var has_end_punctuation = (hasEndPunctuation);

// EXTERNAL MODULE: ./src/client/components/offers/serializers/placeholder/index.tsx
var placeholder = __webpack_require__(44724);
;// CONCATENATED MODULE: ./src/client/components/offers/banner/components/offer-header/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n\n  & > p {\n    display: inline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var PortableTextInline = (0,styled_components_browser_esm["default"])(ahm_ui/* PortableText */.YI).withConfig({
    componentId: "sc-64a49240-0"
})(_templateObject());
var OfferBannerHeader = function(param) {
    var header = param.header, placeholders = param.placeholders, offer = param.offer, rewards = param.rewards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableTextInline, {
        typeSerializers: {
            placeholder: (0,placeholder/* default */.Z)({
                offer: offer,
                placeholders: placeholders,
                rewards: rewards
            })
        },
        source: generate_portable_text_default()(header)
    });
};
/* harmony default export */ var offer_header = (OfferBannerHeader);

// EXTERNAL MODULE: ./src/client/components/offers/images/offer-tag.svg
var offer_tag = __webpack_require__(9788);
// EXTERNAL MODULE: ./src/client/selectors/select-referral-code/index.ts
var select_referral_code = __webpack_require__(25535);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-active-promo-offer/index.ts
var use_get_active_promo_offer = __webpack_require__(8235);
;// CONCATENATED MODULE: ./src/client/components/offers/banner/index.tsx


function banner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 1rem;\n\n  ",
        "\n"
    ]);
    banner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var OfferBannerSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-4f5fe7cd-0"
})(banner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.purpleTint;
}, function(param) {
    var isInHeroBanner = param.isInHeroBanner, theme = param.theme;
    return isInHeroBanner && "\n      border-bottom: 1px solid ".concat(theme.colors.purple, ";\n\n      @media (min-width: ").concat(theme.media.sm, ") {\n        border-left: 0.5rem solid ").concat(theme.colors.black, ";\n        border-right: 0.5rem solid ").concat(theme.colors.black, ";\n        margin-left: auto;\n        margin-right: auto;\n        max-width: ").concat(theme.grid.wrapperWidthExtraExtraLarge, ";\n      }\n  ");
});
var CodeCopyInline = (0,styled_components_browser_esm["default"])(ahm_ui/* CodeCopy */.ZX).withConfig({
    componentId: "sc-4f5fe7cd-1"
})(_templateObject1());
var StyledCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-4f5fe7cd-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledSpan = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-4f5fe7cd-3"
})(_templateObject3());
var OfferBanner = function(param) {
    var filterProductId = param.filterProductId, overrideOffers = param.overrideOffers, placeholders = param.placeholders, _targetSegment = param.targetSegment, targetSegment = _targetSegment === void 0 ? constants/* TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */.TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE : _targetSegment, presaleSentence = param.presaleSentence, presaleEnd = param.presaleEnd, rewards = param.rewards, isInHeroBanner = param.isInHeroBanner;
    var ref, ref1, ref2;
    var activeOffers = (0,use_get_active_promo_offer/* default */.Z)({
        skip: !(0,fp.isEmpty)(overrideOffers),
        targetSegment: targetSegment
    }).activeOffers;
    var referralCode = (0,es/* useSelector */.v9)(select_referral_code/* default */.Z);
    if ((0,fp.isEmpty)(activeOffers) && (0,fp.isEmpty)(overrideOffers)) {
        return null;
    }
    var getOffersToDisplay = function() {
        var offers = overrideOffers || activeOffers;
        return filterProductId ? (0,filterOffers/* default */.Z)({
            filterProductId: filterProductId,
            offers: offers
        }) : offers;
    };
    var offer = (0,fp.last)(getOffersToDisplay());
    var ref3 = (0,get_content_for_offer/* default */.Z)(offer, referralCode), ends = ref3.ends, header = ref3.header, promoCode = ref3.promoCode, subtext = ref3.subtext;
    var headerText = (ref = generate_portable_text_default()(header)) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.text;
    // adding whitespace between sentences
    var endOfSentence = has_end_punctuation(headerText) ? " " : ". ";
    var ref4, ref5;
    var allOfferCopy = {
        // @ts-expect-error - Automatic, Please fix when editing this file
        value: (0,_to_consumable_array/* default */.Z)((ref4 = subtext === null || subtext === void 0 ? void 0 : subtext.value) !== null && ref4 !== void 0 ? ref4 : {}).concat([
            {
                value: " "
            }
        ], (0,_to_consumable_array/* default */.Z)((ref5 = ends === null || ends === void 0 ? void 0 : ends.value) !== null && ref5 !== void 0 ? ref5 : {}))
    };
    var offerText = subtext && ends ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: generate_portable_text_default()(allOfferCopy)
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: generate_portable_text_default()(subtext || ends)
    });
    var ref6, ref7;
    var presaleTextSummary = presaleSentence && presaleEnd ? {
        value: (0,_to_consumable_array/* default */.Z)((ref6 = presaleSentence === null || presaleSentence === void 0 ? void 0 : presaleSentence.value) !== null && ref6 !== void 0 ? ref6 : {}).concat([
            {
                value: " "
            }
        ], (0,_to_consumable_array/* default */.Z)((ref7 = presaleEnd === null || presaleEnd === void 0 ? void 0 : presaleEnd.value) !== null && ref7 !== void 0 ? ref7 : {}))
    } : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferBannerSection, {
        isInHeroBanner: isInHeroBanner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCol, {
                    df: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                        src: offer_tag/* default.src */.Z.src,
                        alt: "Offer"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
                    xs: 12,
                    df: 11,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.H2, {
                            looksLike: "h5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_header, {
                                    header: header,
                                    offer: offer,
                                    placeholders: placeholders,
                                    rewards: rewards
                                }),
                                endOfSentence,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                    children: [
                                        "Use ",
                                        promoCode !== referralCode && "our",
                                        " code:"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeCopyInline, {
                                    asTextLink: true,
                                    codeValue: promoCode
                                })
                            ]
                        }),
                        presaleTextSummary ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: generate_portable_text_default()(presaleTextSummary)
                        }) : offerText
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var banner = (OfferBanner);


/***/ }),

/***/ 60202:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

// @ts-expect-error - Automatic, Please fix when editing this file
var getCodeType = function(offer) {
    var ref, ref1;
    return offer === null || offer === void 0 ? void 0 : (ref = offer.canBeRedeemedWithPromoCode) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.codeType;
};
/* harmony default export */ __webpack_exports__["Z"] = (getCodeType);


/***/ }),

/***/ 22979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13294);
/* harmony import */ var _ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_code_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60202);


// @ts-expect-error - Automatic, Please fix when editing this file
var getIsReferralCodeType = function(offer) {
    return (0,_get_code_type__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(offer) === (_ahmdigital_constants__WEBPACK_IMPORTED_MODULE_0___default().OFFER_CODE_TYPE.REFERRAL);
};
/* harmony default export */ __webpack_exports__["Z"] = (getIsReferralCodeType);


/***/ }),

/***/ 8235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_offers_lib_model_offers_find_active_by_target_segment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22021);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28937);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93590);
/* harmony import */ var _cms_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6465);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10453);
/* harmony import */ var _use_get_all_offers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41684);

// @ts-expect-error - Automatic, Please fix when editing this file







var useGetActivePromoOffer = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _referrerAttribution = ref.referrerAttribution, referrerAttribution = _referrerAttribution === void 0 ? null : _referrerAttribution, _targetSegment = ref.targetSegment, targetSegment = _targetSegment === void 0 ? _cms_constants__WEBPACK_IMPORTED_MODULE_3__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE : _targetSegment, _skip = ref.skip, skip = _skip === void 0 ? false : _skip;
    var isSwagReferrer = referrerAttribution === _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__.SWAG_SOURCE_CODE;
    var useLiveFiltering = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].useLiveFiltering */ .Z.useLiveFiltering, asAtDate = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].asAtDate */ .Z.asAtDate, asAtTime = _cms_client__WEBPACK_IMPORTED_MODULE_5__/* ["default"].asAtTime */ .Z.asAtTime;
    var effectiveDate = // @ts-expect-error - Automatic, Please fix when editing this file
    useLiveFiltering && asAtDate && asAtDate !== _cms_constants__WEBPACK_IMPORTED_MODULE_3__/* .NOW */ .Kp ? moment__WEBPACK_IMPORTED_MODULE_2___default()("".concat(asAtDate, " ").concat(asAtTime), "".concat(_ahm_constants__WEBPACK_IMPORTED_MODULE_6__/* ["default"].DATE_FORMAT.STANDARD */ .Z.DATE_FORMAT.STANDARD, " HH:mm")) : moment__WEBPACK_IMPORTED_MODULE_2___default()();
    var ref1 = (0,_use_get_all_offers__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        skip: skip
    }), allOffers = ref1.allOffers, loading = ref1.loading;
    // Do this last to prevent a rule-of-hooks lint failure
    if (skip) {
        return {
            activeOffers: null,
            loading: false
        };
    }
    if (isSwagReferrer) {
        var swagOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
            var ref;
            return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(offer === null || offer === void 0 ? void 0 : (ref = offer.identifier) === null || ref === void 0 ? void 0 : ref.current, _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_4__.SWAG_OFFER_IDS);
        }, allOffers);
        return {
            activeOffers: swagOffers,
            loading: loading
        };
    }
    // Only returns only last three active offers as we only want to display the last three that are active and this reduces additional filtering later on.
    var activeOffers = (0,_ahmdigital_offers_lib_model_offers_find_active_by_target_segment__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(allOffers, targetSegment, {
        effectiveDate: effectiveDate.toDate()
    }).slice(-3);
    return {
        activeOffers: activeOffers,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetActivePromoOffer);


/***/ }),

/***/ 41684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_get_all_offers; },
  "p": function() { return /* binding */ generateOffersQuery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/get-melbourne-timezone-moment/index.js
var get_melbourne_timezone_moment = __webpack_require__(80605);
var get_melbourne_timezone_moment_default = /*#__PURE__*/__webpack_require__.n(get_melbourne_timezone_moment);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/is-expired/index.js
var is_expired = __webpack_require__(33873);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/cms/fragments/how-to-fields/index.ts
var how_to_fields = __webpack_require__(13535);
// EXTERNAL MODULE: ./src/client/logging/index.ts
var logging = __webpack_require__(99846);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-offer-query/index.ts
var use_offer_query = __webpack_require__(34914);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-validation-errors/get-definition-errors/index.js
var get_definition_errors = __webpack_require__(15237);
;// CONCATENATED MODULE: ./src/client/components/offers/logic/validate-offer/index.ts

// @ts-expect-error - Automatic, Please fix when editing this file


// @ts-expect-error - Automatic, Please fix when editing this file
var validateOffer = function(offer) {
    var errors = (0,get_definition_errors/* default */.Z)(offer);
    if (!(0,fp.isEmpty)(errors)) {
        logging/* default.getLogger */.Z.getLogger().error("Offer validation error", {
            errors: errors,
            offer: offer
        });
    }
};
/* harmony default export */ var validate_offer = (validateOffer);

;// CONCATENATED MODULE: ./src/client/components/offers/logic/use-get-all-offers/index.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AllOffer {\n    allOffer",
        " {\n      _id\n      _type\n      id: _id\n      _createdAt\n      ",
        "\n      canBeRedeemedWithPromoCode {\n        code {\n          current\n        }\n        codeType\n        description: descriptionRaw\n      }\n      minimumGapInCoverDays\n      detailsTeaser\n      targetsSegments {\n        identifier {\n          current\n        }\n      }\n      identifier {\n        current\n      }\n      ",
        "\n      offerTypes {\n        _id\n        name\n        identifier {\n          current\n        }\n        slogan: sloganRaw\n        description: descriptionRaw\n        givesAccessToOneOfRewards {\n          identifier {\n            current\n          }\n          name\n        }\n        fulfilledAfterDays\n        ",
        "\n        ",
        "\n        ",
        "\n        summary\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



// @ts-expect-error - Automatic, Please fix when editing this file






var ORGANISATION_FIELDS = "\n  offeredByOrganization {\n    name\n    identifier {\n      current\n    }\n    logo {\n      ".concat(constants/* GRAPHQL.IMAGE_FIELDS */.gQ.IMAGE_FIELDS, "\n    }\n    termsAndConditions:termsAndConditionsRaw\n    isFulfilledUsingSourceCodes {\n      appliesToServiceChannel {\n        name\n      }\n      code {\n        current\n      }\n    }\n  }\n");
var HOW_TO_FIELDS = "\n  howTo {\n    ...howToFields\n  }\n";
// @ts-expect-error - Automatic, Please fix when editing this file
var generateOffersQuery = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = ref.filter, _withOrganisation = ref.withOrganisation, withOrganisation = _withOrganisation === void 0 ? false : _withOrganisation, _withHowTo = ref.withHowTo, withHowTo = _withHowTo === void 0 ? false : _withHowTo;
    return (0,core.gql)(_templateObject(), filter ? "(where: ".concat(filter, ")") : "", constants/* GRAPHQL.RELEASE */.gQ.RELEASE, withHowTo ? HOW_TO_FIELDS : "", constants/* GRAPHQL.OFFER_TYPE_CONDITIONS */.gQ.OFFER_TYPE_CONDITIONS, withOrganisation ? ORGANISATION_FIELDS : "", constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, withHowTo ? how_to_fields/* default */.Z : "");
};
var useGetAllOffers = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _skip = _param.skip, skip = _skip === void 0 ? false : _skip, opts = (0,_object_without_properties/* default */.Z)(_param, [
        "skip"
    ]);
    // @ts-expect-error - Automatic, Please fix when editing this file
    var ref = (0,use_offer_query/* default */.Z)(generateOffersQuery(opts), {
        skip: skip
    }), data = ref.data, error = ref.error, loading = ref.loading;
    if (skip) {
        return {
            allOffers: [],
            loading: false
        };
    }
    var allOffers = data === null || data === void 0 ? void 0 : data.allOffer;
    if (!loading && error) {
        logging/* default.getLogger */.Z.getLogger().error("graphql::error - Failed to get offers from CMS", {
            error: error,
            opts: opts
        });
        return {
            allOffers: [],
            loading: false
        };
    }
    // Validate all offers but don't bother for offers that are out of date
    var now = get_melbourne_timezone_moment_default()();
    // eslint-disable-next-line lodash-fp/no-unused-result
    (0,fp.flow)((0,fp.reject)(function(offer) {
        return (0,is_expired/* default */.Z)(offer, {
            effectiveDate: now
        });
    }), (0,fp.forEach)((0,fp.unary)(validate_offer)))(allOffers);
    return {
        allOffers: allOffers,
        loading: loading
    };
};
/* harmony default export */ var use_get_all_offers = (useGetAllOffers);



/***/ }),

/***/ 34914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46829);
/* harmony import */ var _cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92002);





// @ts-expect-error - Automatic, Please fix when editing this file
var useOfferQuery = function(gqlQuery, options) {
    var ref;
    var response = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__.useQuery)(gqlQuery, options);
    var data = response.data;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, response), {
        data: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNil)(data) ? data : {
            allOffer: (0,_cms_utils_unique_content_with_draft_precedence__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((ref = response.data) === null || ref === void 0 ? void 0 : ref.allOffer)
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (useOfferQuery);


/***/ }),

/***/ 44724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40844);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99846);






var placeholderSerializer = function(param) {
    var offer = param.offer, offerTypeId = param.offerTypeId, placeholders = param.placeholders, rewards = param.rewards;
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(value) {
        var ref, ref1;
        var matchedPlaceholder = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.find)({
            _id: value === null || value === void 0 ? void 0 : (ref = value.node) === null || ref === void 0 ? void 0 : ref._ref
        }, placeholders);
        var placeholderId = matchedPlaceholder === null || matchedPlaceholder === void 0 ? void 0 : (ref1 = matchedPlaceholder.identifier) === null || ref1 === void 0 ? void 0 : ref1.current;
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | undefined' is not assignable to type 'string'.
        var result = _ahmdigital_logic_lib_content_offers_shared_replace_placeholder__WEBPACK_IMPORTED_MODULE_4___default()({
            offer: offer,
            offerTypeId: offerTypeId,
            placeholderId: placeholderId,
            rewards: rewards
        });
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.isNull)(result)) {
            _logging__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getLogger */ .Z.getLogger().error("Failed to replace offer terms and conditions placeholder", {
                matchedPlaceholder: matchedPlaceholder,
                offer: offer,
                value: value
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_2__/* .Strong */ .cK, {
                children: [
                    "[[PLACEHOLDER:",
                    placeholderId,
                    "]]"
                ]
            });
        }
        return result;
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (placeholderSerializer);


/***/ }),

/***/ 95897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91282);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59182);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85224);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72679);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52068);
/* harmony import */ var _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _logic_get_is_referral_code_type__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22979);
/* harmony import */ var _utils_get_offer_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88290);








var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null);
var getContentForOffer = function(offer, referralCode) {
    var image = (0,_utils_get_offer_image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(offer);
    var header = _ahmdigital_logic_lib_content_offers_unqualified_get_header__WEBPACK_IMPORTED_MODULE_1___default()(offer);
    var subtext = _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default()(offer, false);
    var sublist = _ahmdigital_logic_lib_content_offers_unqualified_get_subtext__WEBPACK_IMPORTED_MODULE_5___default()(offer, true);
    var isReferralCodeType = (0,_logic_get_is_referral_code_type__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(offer);
    var promoCode = isReferralCodeType ? referralCode : getOrNull("value", _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code__WEBPACK_IMPORTED_MODULE_3___default()(offer));
    var promoCodeDescription = getOrNull("value", _ahmdigital_logic_lib_content_offers_unqualified_get_promo_code_description__WEBPACK_IMPORTED_MODULE_4___default()(offer));
    var subtextPrefix = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "offerTypes[0].summary", offer);
    var ends = _ahmdigital_logic_lib_content_offers_unqualified_get_offer_end_summary__WEBPACK_IMPORTED_MODULE_2___default()(offer);
    return {
        ends: ends,
        header: header,
        image: image,
        promoCode: promoCode,
        promoCodeDescription: promoCodeDescription,
        sublist: sublist,
        subtext: subtext,
        subtextPrefix: subtextPrefix
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getContentForOffer);


/***/ }),

/***/ 91186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_get_eligible_rewards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14282);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_get_upsell_applicable_rewards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80336);
/* harmony import */ var _ahmdigital_offers_lib_model_offer_is_eligible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40932);

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file
var filterOffers = function(param) {
    var filterProductId = param.filterProductId, offers = param.offers;
    var scenarioForRewardEligibility = {
        productId: filterProductId
    };
    var eligibleOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
        return (0,_ahmdigital_offers_lib_model_offer_is_eligible__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(offer, scenarioForRewardEligibility);
    })(offers);
    var filteredOffers = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(eligibleOffers) ? (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.filter)(function(offer) {
        var eligibleRewards = (0,_ahmdigital_offers_lib_model_offer_get_eligible_rewards__WEBPACK_IMPORTED_MODULE_1__["default"])(offer, scenarioForRewardEligibility);
        var upsellApplicableRewards = (0,_ahmdigital_offers_lib_model_offer_get_upsell_applicable_rewards__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(offer, scenarioForRewardEligibility);
        var rewards = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;
        return !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(rewards);
    })(offers) : eligibleOffers;
    return filteredOffers;
};
/* harmony default export */ __webpack_exports__["Z"] = (filterOffers);


/***/ }),

/***/ 88290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51413);

// @ts-expect-error - Automatic, Please fix when editing this file
var getOfferImage = function(offer) {
    var ref, ref1;
    var imageObject = offer === null || offer === void 0 ? void 0 : (ref = offer.offerTypes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.imageObject;
    return (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        imageObject: imageObject,
        width: 400
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getOfferImage);


/***/ }),

/***/ 71221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ CONTENT_SECTIONS; }
/* harmony export */ });
/* unused harmony export CONSIDERATION_TYPES */
var CONTENT_SECTIONS = {
    AWARD: "Award",
    COMMON_QUESTIONS: "CommonQuestions",
    CONTACT_DETAILS: "ContactDetails",
    HEADER: "header",
    OFFER: "offer",
    PRODUCT_LISTING: "ProductListing",
    SELLING_POINTS_GROUP: "SellingPointGroup",
    TILES: "ContentTiles",
    VALUE_PROPOSITIONS: "ValuePropositionsObject"
};
var CONSIDERATION_TYPES = (/* unused pure expression or super */ null && ([
    "health-insurance-ccs"
]));


/***/ }),

/***/ 17228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ consideration_landing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/portable-text-to-plain/index.js
var portable_text_to_plain = __webpack_require__(64355);
var portable_text_to_plain_default = /*#__PURE__*/__webpack_require__.n(portable_text_to_plain);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/pages/consideration-landing/content/sections/index.ts
var sections = __webpack_require__(71221);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/award/index.tsx + 1 modules
var award = __webpack_require__(87902);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/common-questions/index.tsx
var common_questions = __webpack_require__(60333);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/livechat/lib/actions/index.js
var actions = __webpack_require__(88530);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/pages/contact-us/components/contact-options/index.tsx + 7 modules
var contact_options = __webpack_require__(53753);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/contact-details/index.tsx + 2 modules
var contact_details = __webpack_require__(76701);
// EXTERNAL MODULE: ./src/client/actions/drawer/index.ts
var drawer = __webpack_require__(56774);
// EXTERNAL MODULE: ./src/client/pages/contact-us/components/decision-tree/options/utils/format-contact-options/index.tsx
var format_contact_options = __webpack_require__(56515);
// EXTERNAL MODULE: ./src/client/utils/livechat.ts
var livechat = __webpack_require__(47689);
// EXTERNAL MODULE: ./src/client/components/live-chat/live-chat-status/index.tsx + 1 modules
var live_chat_status = __webpack_require__(26183);
// EXTERNAL MODULE: ./src/client/components/offers/logic/use-get-all-placeholders/index.ts
var use_get_all_placeholders = __webpack_require__(38153);
// EXTERNAL MODULE: ./src/client/components/live-chat/use-live-chat/index.ts
var use_live_chat = __webpack_require__(22303);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/components/contact-details/index.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  padding: 1rem 0;\n\n  @media (min-width: ",
        ") {\n    align-items: flex-end;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 1rem;\n  width: 100%;\n  padding-top: ",
        ";\n\n  &:first-child {\n    margin-bottom: 1rem;\n  }\n\n  @media (min-width: ",
        ") {\n    width: 12rem;\n\n    &:first-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// @ts-expect-error - Automatic, Please fix when editing this file













var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dc2520e3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-dc2520e3-1"
})(_templateObject1(), function(param) {
    var isLink = param.isLink;
    return isLink ? "1.275rem" : "0.75rem";
}, function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var ContactDetails = function(param) {
    var items = param.items, name = param.name;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var placeholders = (0,use_get_all_placeholders/* default */.Z)().placeholders;
    var openGetACallBackDrawer = (0,react.useCallback)(function() {
        drawer/* default.openDrawer */.Z.openDrawer(ui.DRAWER_IDS.GET_A_CALL_BACK)(dispatch);
    }, [
        dispatch
    ]);
    var launchLivechat = (0,react.useCallback)(function() {
        actions/* default.launch */.Z.launch(livechat/* default */.Z)(dispatch);
    }, [
        dispatch
    ]);
    var ref2 = (0,use_live_chat/* default */.Z)(), isAbcSupportedAndAvailable = ref2.isAbcSupportedAndAvailable, isOnline = ref2.isOnline, messageId = ref2.messageId;
    var formattedContactOptions = (0,format_contact_options/* default */.Z)({
        id: format_contact_options/* CONTACT_OPTION_ID.LOOKING_TO_JOIN */.X.LOOKING_TO_JOIN,
        items: items,
        placeholders: placeholders,
        title: name
    });
    var phoneContact = (0,fp.find)(function(item) {
        return item.item.type === "phone";
    })(items);
    var phoneContactItem = phoneContact === null || phoneContact === void 0 ? void 0 : phoneContact.item;
    var messageOption = (0,fp.find)({
        contactOptionId: contact_options/* optionConstantIds.lookingToJoinChatBox */.e.lookingToJoinChatBox
    })(formattedContactOptions.options);
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'contactOptionData' does not exist on type '{ contactOptionId: string; }'. Did you mean 'contactOptionId'?
    var offline = messageOption === null || messageOption === void 0 ? void 0 : (ref = messageOption.contactOptionData) === null || ref === void 0 ? void 0 : ref.offline;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'contactOptionData' does not exist on type '{ contactOptionId: string; }'. Did you mean 'contactOptionId'?
    var online = messageOption === null || messageOption === void 0 ? void 0 : (ref1 = messageOption.contactOptionData) === null || ref1 === void 0 ? void 0 : ref1.online;
    var getMessageUsButton = function() {
        if (isAbcSupportedAndAvailable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                isLink: true,
                to: "".concat(ahm_constants/* default.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT */.Z.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT).concat(messageId),
                variant: [
                    "border",
                    "smallPadding",
                    "white"
                ],
                children: isOnline ? online.buttonText : offline.buttonText
            });
        }
        if (isOnline) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                onClick: launchLivechat,
                variant: [
                    "border",
                    "smallPadding",
                    "white"
                ],
                children: online.buttonText
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
            isLink: true,
            to: offline.buttonUrl,
            variant: [
                "border",
                "smallPadding",
                "white"
            ],
            children: offline.buttonText
        });
    };
    var customActionsComponent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(live_chat_status/* default */.Z, {
                isOnline: isOnline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                children: [
                    offline && online && getMessageUsButton(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        onClick: openGetACallBackDrawer,
                        variant: [
                            "border",
                            "smallPadding",
                            "white"
                        ],
                        children: "Get a call back"
                    })
                ]
            })
        ]
    });
    var contactProps = {
        contact: phoneContactItem,
        customActionsComponent: customActionsComponent,
        name: name
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_details/* default */.Z, (0,_object_spread/* default */.Z)({}, contactProps));
};
/* harmony default export */ var components_contact_details = (ContactDetails);

// EXTERNAL MODULE: ./src/client/components/content-tiles-section/index.tsx
var content_tiles_section = __webpack_require__(50739);
// EXTERNAL MODULE: ./src/utils/head.tsx
var head = __webpack_require__(40985);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/inclusions/index.tsx + 5 modules
var inclusions = __webpack_require__(63147);
// EXTERNAL MODULE: ./src/client/components/offers/banner/index.tsx + 2 modules
var banner = __webpack_require__(9010);
// EXTERNAL MODULE: ./src/client/pages/consideration-landing/components/page-sections/index.tsx
var page_sections = __webpack_require__(85878);
// EXTERNAL MODULE: ./src/client/components/sections/products-section/index.tsx + 4 modules
var products_section = __webpack_require__(91331);
// EXTERNAL MODULE: ./src/client/components/request-a-call/drawer/index.tsx
var request_a_call_drawer = __webpack_require__(68442);
// EXTERNAL MODULE: ./src/client/pages/insurance/components/value-propositions/index.tsx
var value_propositions = __webpack_require__(37594);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/index.tsx

















var getComponents = function() {
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.AWARD */.i.AWARD, award/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.HEADER */.i.HEADER, ahm_ui/* HeroBanner */.yo), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.OFFER */.i.OFFER, banner/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS, value_propositions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.SELLING_POINTS_GROUP */.i.SELLING_POINTS_GROUP, inclusions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.TILES */.i.TILES, content_tiles_section/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.CONTACT_DETAILS */.i.CONTACT_DETAILS, components_contact_details), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS, common_questions/* default */.Z), (0,_define_property/* default */.Z)(_obj, sections/* CONTENT_SECTIONS.PRODUCT_LISTING */.i.PRODUCT_LISTING, products_section/* default */.Z), _obj;
};
var ConsiderationLandingPage = function(param) {
    var content = param.content;
    var ref;
    var metadataObject = content === null || content === void 0 ? void 0 : (ref = content.explainedTerm) === null || ref === void 0 ? void 0 : ref.metadataObject;
    var title = (metadataObject === null || metadataObject === void 0 ? void 0 : metadataObject.name) || "";
    var description = (metadataObject === null || metadataObject === void 0 ? void 0 : metadataObject.descriptionRaw) || "";
    var titleTemplate = "%s - ahm insurance";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head/* default */.Z, {
                titleTemplate: titleTemplate,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: portable_text_to_plain_default()(description)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_sections/* default */.Z, {
                components: getComponents(),
                content: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(request_a_call_drawer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var consideration_landing = (ConsiderationLandingPage);


/***/ }),

/***/ 68522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ get_content_to_render; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/pages/consideration-landing/content/sections/index.ts
var sections = __webpack_require__(71221);
// EXTERNAL MODULE: ./pages/utils/is-in-explained-blocklist/index.ts
var is_in_explained_blocklist = __webpack_require__(72487);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var product = __webpack_require__(43735);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/extras-product-listing-content/index.ts



var getExtrasProductListingContent = function(products) {
    var recommendedProductIds = [
        ahm_constants/* default.PRODUCT.VALUE_EXTRAS */.Z.PRODUCT.VALUE_EXTRAS,
        ahm_constants/* default.PRODUCT.BLACK_60_EXTRAS */.Z.PRODUCT.BLACK_60_EXTRAS,
        ahm_constants/* default.PRODUCT.LIFESTYLE_EXTRAS */.Z.PRODUCT.LIFESTYLE_EXTRAS, 
    ];
    var recommendedProducts = product/* default.getProducts */.Z.getProducts(products, recommendedProductIds);
    return {
        compareButtonText: "See more extras products",
        compareButtonToLink: ahm_constants/* default.URLS.SALES.PRODUCT_LISTING_EXTRAS */.Z.URLS.SALES.PRODUCT_LISTING_EXTRAS,
        data: {
            title: "Find extras cover that suits your needs"
        },
        orderIndex: 3,
        products: recommendedProducts,
        type: sections/* CONTENT_SECTIONS.PRODUCT_LISTING */.i.PRODUCT_LISTING,
        withBorder: true
    };
};
/* harmony default export */ var extras_product_listing_content = (getExtrasProductListingContent);

;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-awards-content/index.ts


var mapAwardsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    // TODO: check format of data from cmsSectionContent once Award is on the Explained Term model
    var mappedCmsContent = {
        imageObject: cmsSectionContent.imageObject,
        name: cmsSectionContent.name,
        orderIndex: cmsSectionContent.orderIndex,
        summaryRaw: cmsSectionContent.summary,
        type: sections/* CONTENT_SECTIONS.AWARD */.i.AWARD
    };
    return mappedCmsContent;
};
/* harmony default export */ var map_awards_content = (mapAwardsContent);

;// CONCATENATED MODULE: ./public/assets/img/travel-insurance/contact-us.svg
/* harmony default export */ var contact_us = ({"src":"/_next/static/media/contact-us.9518020d.svg","height":200,"width":400});
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-contact-content/index.ts



var mapContactContent = function(param) {
    var cmsData = param.cmsData;
    if ((0,fp.isEmpty)(cmsData)) {
        return null;
    }
    var mappedCmsContent = {
        image: {
            alt: "contact us",
            src: contact_us.src
        },
        items: cmsData.items,
        name: cmsData.name,
        orderIndex: 999,
        type: sections/* CONTENT_SECTIONS.CONTACT_DETAILS */.i.CONTACT_DETAILS
    };
    return mappedCmsContent;
};
/* harmony default export */ var map_contact_content = (mapContactContent);

;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-header-content/index.ts


var mapHeaderContent = function(param) {
    var cmsData = param.cmsData, removePaddingTop = param.removePaddingTop;
    var ref, ref1;
    if ((0,fp.isEmpty)(cmsData)) {
        return null;
    }
    var urlObject = cmsData.urlObject, imageObject = cmsData.imageObject, summary = cmsData.summary, slogan = cmsData.slogan;
    var mappedCmsContent = {
        cta: {
            title: urlObject === null || urlObject === void 0 ? void 0 : urlObject.name,
            to: urlObject === null || urlObject === void 0 ? void 0 : urlObject.url
        },
        image: {
            alt: imageObject === null || imageObject === void 0 ? void 0 : imageObject.caption,
            src: imageObject === null || imageObject === void 0 ? void 0 : (ref = imageObject.image) === null || ref === void 0 ? void 0 : (ref1 = ref.asset) === null || ref1 === void 0 ? void 0 : ref1.url
        },
        orderIndex: 1,
        removePaddingTop: removePaddingTop,
        subtitle: summary,
        title: slogan,
        type: sections/* CONTENT_SECTIONS.HEADER */.i.HEADER
    };
    return mappedCmsContent;
};
/* harmony default export */ var map_header_content = (mapHeaderContent);

;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-offer-content/index.ts



var mapOfferContent = function(offerContentToRender) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, offerContentToRender), {
        isInHeroBanner: true,
        orderIndex: 0,
        type: sections/* CONTENT_SECTIONS.OFFER */.i.OFFER
    });
};
/* harmony default export */ var map_offer_content = (mapOfferContent);

// EXTERNAL MODULE: ./src/client/utils/get-formatted-question-for-accordion/index.ts
var get_formatted_question_for_accordion = __webpack_require__(80365);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-questions-content/index.ts



var mapQuestionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    return {
        items: (0,get_formatted_question_for_accordion/* default */.Z)(cmsSectionContent.questions),
        orderIndex: cmsSectionContent.orderIndex,
        type: sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS
    };
};
/* harmony default export */ var map_questions_content = (mapQuestionsContent);

;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-selling-points-content/index.ts


var mapSellingPointsContent = function(param) {
    var refersToContent = param.refersToContent;
    var sellingPointGroups = (0,fp.filter)(function(section) {
        return (0,fp.get)("__typename")(section) === sections/* CONTENT_SECTIONS.SELLING_POINTS_GROUP */.i.SELLING_POINTS_GROUP;
    })(refersToContent);
    if ((0,fp.isEmpty)(sellingPointGroups)) {
        return null;
    }
    // TODO: hard-coded for now as title is not on the model. Maybe derive this from a data file based on the
    // page being rendered (which is just /health-insurance for now but could be something else in the future)
    var title = "Find private health cover to suit your needs";
    var groups = (0,fp.map)(function(sellingPointGroup) {
        var ref, ref1;
        return {
            contentTitle: sellingPointGroup.name,
            cta: {
                name: (ref = sellingPointGroup.cta) === null || ref === void 0 ? void 0 : ref.name,
                url: (ref1 = sellingPointGroup.cta) === null || ref1 === void 0 ? void 0 : ref1.url
            },
            description: sellingPointGroup.summary,
            sellingPoints: (0,fp.map)(function(sellingPoint) {
                return {
                    description: sellingPoint.summary,
                    title: sellingPoint.name
                };
            })(sellingPointGroup.sellingPointGroup),
            tabTitle: sellingPointGroup.name,
            title: sellingPointGroup.name
        };
    })(sellingPointGroups);
    var mappedCmsContent = {
        groups: groups,
        orderIndex: (0,fp.get)("orderIndex", (0,fp.head)(sellingPointGroups)),
        title: title,
        type: sections/* CONTENT_SECTIONS.SELLING_POINTS_GROUP */.i.SELLING_POINTS_GROUP
    };
    return mappedCmsContent;
};
/* harmony default export */ var map_selling_points_content = (mapSellingPointsContent);

// EXTERNAL MODULE: ./src/client/pages/explained-term/detail/utils/get-content-tiles-data/index.ts + 1 modules
var get_content_tiles_data = __webpack_require__(24699);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-tiles-content/index.ts



var mapTilesContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    var tilesData = cmsSectionContent === null || cmsSectionContent === void 0 ? void 0 : cmsSectionContent.tiles;
    var serviceTiles = (0,fp.filter)(function(tileType) {
        return tileType.type === "service";
    }, tilesData);
    var explainedTermTiles = (0,fp.filter)(function(tileType) {
        return tileType.type === "explainedTerm";
    }, tilesData);
    var contentTiles = (0,get_content_tiles_data/* default */.Z)({
        explainedTermTiles: explainedTermTiles,
        serviceTiles: serviceTiles
    });
    return {
        contentTiles: contentTiles,
        orderIndex: cmsSectionContent.orderIndex,
        type: sections/* CONTENT_SECTIONS.TILES */.i.TILES
    };
};
/* harmony default export */ var map_tiles_content = (mapTilesContent);

// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/map-value-propositions-content/index.ts



var mapValuePropositionsContent = function(param) {
    var cmsSectionContent = param.cmsSectionContent;
    var ref, ref1;
    if ((0,fp.isEmpty)(cmsSectionContent)) {
        return null;
    }
    // Displaying no more than 6 tiles as per design requirement
    var propositionsToShow = (0,fp.take)(6, cmsSectionContent.valuePropositionsReference);
    var mappedCmsContent = {
        cta: {
            title: (ref = cmsSectionContent.urlObject) === null || ref === void 0 ? void 0 : ref.name,
            to: (ref1 = cmsSectionContent.urlObject) === null || ref1 === void 0 ? void 0 : ref1.url
        },
        orderIndex: cmsSectionContent.orderIndex,
        tiles: (0,fp.map)(function(valueProposition) {
            return {
                image: (0,get_image_attributes/* default */.Z)({
                    height: 352,
                    imageObject: valueProposition === null || valueProposition === void 0 ? void 0 : valueProposition.imageObject
                }),
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'summary' does not exist on type 'ValueProposition'.
                summary: valueProposition === null || valueProposition === void 0 ? void 0 : valueProposition.summary,
                title: valueProposition === null || valueProposition === void 0 ? void 0 : valueProposition.name,
                urlObject: valueProposition === null || valueProposition === void 0 ? void 0 : valueProposition.urlObject
            };
        }, propositionsToShow),
        title: cmsSectionContent.title,
        type: sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS,
        withSimpleBit: false
    };
    return mappedCmsContent;
};
/* harmony default export */ var map_value_propositions_content = (mapValuePropositionsContent);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
;// CONCATENATED MODULE: ./src/client/pages/consideration-landing/utils/get-content-to-render/index.ts
















var mapWithIndex = (0,uncap_fp_iterator/* default */.Z)(fp.map);
var getContentToRender = function(param) {
    var cmsData = param.cmsData, offerContentToRender = param.offerContentToRender, products = param.products, slug = param.slug;
    var explainedTermData = cmsData === null || cmsData === void 0 ? void 0 : cmsData.explainedTerm;
    var contactData = cmsData === null || cmsData === void 0 ? void 0 : cmsData.contact;
    var sectionsArray = [];
    var removePaddingTop = !(0,fp.isEmpty)(offerContentToRender);
    var headerSection = map_header_content({
        cmsData: explainedTermData,
        removePaddingTop: removePaddingTop
    });
    var offerSection = map_offer_content(offerContentToRender);
    var isExtrasCoverPage = slug === is_in_explained_blocklist/* EXPLAINED_TERMS_SLUG_BLOCKLIST.EXTRAS_COVER_LANDING_PAGE */.z.EXTRAS_COVER_LANDING_PAGE;
    sectionsArray.push(offerSection);
    sectionsArray.push(headerSection);
    // @ts-expect-error - Automatic, Please fix when editing this file
    if (isExtrasCoverPage) sectionsArray.push(extras_product_listing_content(products));
    var contentSections = explainedTermData === null || explainedTermData === void 0 ? void 0 : explainedTermData.refersToContent;
    var sectionsWithIndex = mapWithIndex(function(section, index) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, section), {
            orderIndex: index + 1
        });
    })(contentSections);
    var sellingPointsSection = map_selling_points_content({
        refersToContent: sectionsWithIndex
    });
    sectionsArray.push(sellingPointsSection);
    var formattedSections = sectionsWithIndex.map(function(section) {
        var contentType = section === null || section === void 0 ? void 0 : section.__typename;
        if (contentType === sections/* CONTENT_SECTIONS.VALUE_PROPOSITIONS */.i.VALUE_PROPOSITIONS) {
            return map_value_propositions_content({
                cmsSectionContent: section
            });
        }
        if (contentType === sections/* CONTENT_SECTIONS.TILES */.i.TILES) {
            return map_tiles_content({
                cmsSectionContent: section
            });
        }
        if (contentType === sections/* CONTENT_SECTIONS.COMMON_QUESTIONS */.i.COMMON_QUESTIONS) {
            return map_questions_content({
                cmsSectionContent: section
            });
        }
        // TODO - Award needs to be included in the Explained Term sanity model
        if (contentType === sections/* CONTENT_SECTIONS.AWARD */.i.AWARD) {
            return map_awards_content({
                cmsSectionContent: section
            });
        }
        return null;
    });
    var contactSection = map_contact_content({
        cmsData: contactData
    });
    sectionsArray.push(contactSection);
    var orderedSections = (0,fp.sortBy)("orderIndex", (0,fp.compact)((0,_to_consumable_array/* default */.Z)(sectionsArray).concat((0,_to_consumable_array/* default */.Z)(formattedSections))));
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cmsData), {
        sections: orderedSections
    });
};
/* harmony default export */ var get_content_to_render = (getContentToRender);


/***/ }),

/***/ 93830:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

// @ts-expect-error - Automatic, Please fix when editing this file
var selectHasPartnerReferrer = function(state) {
    var ref;
    return !!(state === null || state === void 0 ? void 0 : (ref = state.referrer) === null || ref === void 0 ? void 0 : ref.hasPartnerReferrer);
};
/* harmony default export */ __webpack_exports__["Z"] = (selectHasPartnerReferrer);


/***/ }),

/***/ 25535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

var getOrNull = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)(null, "referral.code");
var selectReferralCode = getOrNull;
/* harmony default export */ __webpack_exports__["Z"] = (selectReferralCode);


/***/ }),

/***/ 80622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);

var ref;
// @ts-expect-error - Automatic, Please fix when editing this file
var selectTargetSegment = function(state) {
    var ref1;
    return (ref = state === null || state === void 0 ? void 0 : (ref1 = state.referral) === null || ref1 === void 0 ? void 0 : ref1.targetSegment) !== null && ref !== void 0 ? ref : _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectTargetSegment);


/***/ }),

/***/ 41763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var EXTRAS_ONLY_OFFER_TYPE = "extras-only";
var HOSPITAL_ONLY_OFFER_TYPE = "hospital-only";
var filterOffersByProductType = function(lastViewedProductType, offers) {
    var ref = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.groupBy)(function(offer) {
        var ref;
        var offerId = offer === null || offer === void 0 ? void 0 : (ref = offer.identifier) === null || ref === void 0 ? void 0 : ref.current;
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(EXTRAS_ONLY_OFFER_TYPE, offerId)) {
            return "extrasOnlyOffers";
        }
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(HOSPITAL_ONLY_OFFER_TYPE, offerId)) {
            return "hospitalOnlyOffers";
        }
        return "otherOffers";
    })(offers), extrasOnlyOffers = ref.extrasOnlyOffers, hospitalOnlyOffers = ref.hospitalOnlyOffers, otherOffers = ref.otherOffers;
    var prioritisedOffersForProductType = function() {
        if (lastViewedProductType === _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_TYPE.EXTRAS */ .Z.PRODUCT_TYPE.EXTRAS) {
            return extrasOnlyOffers;
        }
        if (lastViewedProductType === _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_TYPE.HOSPITAL */ .Z.PRODUCT_TYPE.HOSPITAL) {
            return hospitalOnlyOffers;
        }
        return otherOffers;
    };
    var offerPriorityWhenNoProductTypeMatch = otherOffers || extrasOnlyOffers || hospitalOnlyOffers;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(prioritisedOffersForProductType()) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(offerPriorityWhenNoProductTypeMatch);
};
/* harmony default export */ __webpack_exports__["Z"] = (filterOffersByProductType);


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

}]);